import React, { type ReactElement } from "react";

import { Flex, Text, Heading } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";

export const ApplicantInsightsSkillsHeader = (): ReactElement => {
  const gt = useI18n();

  return (
    <Flex sx={{ flexDirection: "column", paddingBlockEnd: 12, paddingInlineStart: 4 }}>
      <Heading level={3}>{gt.gettext("Skills match")}</Heading>
      <Text level={1} variant="secondary">
        {gt.gettext("Based on comparing applicant profiles and the job description")}
      </Text>
    </Flex>
  );
};
